import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import { NumberText } from "../NumberText";
var cx = classNames.bind(styles);
export var MobileCard = function MobileCard(_ref) {
  var isTopBorder = _ref.isTopBorder,
    number = _ref.number,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('mobile-card', isTopBorder && 'border-top'),
    "data-t-id": "components-MobileCard"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('mobile-card-content')
  }, children), /*#__PURE__*/React.createElement(NumberText, {
    number: number
  }));
};